module.exports = __webpack_public_path__ + "img/11_NSC_innen_iPad_P.397e46bb.jpg";